<div class="block--bg-image-wrapper-landing-page block">
    <header
        class="v4-header block--header flex-center secondary-header"
        [ngClass]="{ 'header--mobile-menu-open': mobileMenuOpen === true }">
        <div class="v4-header__col-brand">
            <a [routerLink]="'/home' | localize">
                <img
                    class="v4-header__col-brand-img hide-for-wcag"
                    src="{{ assetsPath$ | async }}/logo-landing-page.png"
                    attr.alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
                <img
                    class="v4-header__col-brand-img show-high-contrast-view"
                    src="{{ assetsPath$ | async }}/logo-wcag.png"
                    attr.alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
            </a>
        </div>

        <div class="block-text-landing-page">
            <h1>
                <span
                    >{{ 'LANDING_PAGE_H1_BUY_TICKETS' | translate }}
                    <img class="hide-for-wcag" src="{{ assetsPath$ | async }}/leaf.png" alt="" />
                    <img class="show-high-contrast-view-inherit" src="{{ assetsPath$ | async }}/leaf-wcag.png" alt="" />
                </span>
            </h1>
        </div>

        <div class="v4-header__col-info-links menu-item flex-align-self-baseline">
            <div class="v4-header__info languages" *ngIf="!env.HEADER.HIDE_LANGUAGE_SELECTOR">
                <ridango-header-menu-item
                    [languages]="languages"
                    [selected]="selected"
                    (onLanguageSelected)="changeLanguage($event)">
                </ridango-header-menu-item>
            </div>

            <div class="v4-header__info">
                <div class="v4-header__info-link-burger">
                    <span
                        class="v4-header__info-icon icon header__mobile-menu-icon"
                        (click)="toggleMobileMenu()"
                        (keydown.enter)="toggleMobileMenu()"
                        (keydown.space)="toggleMobileMenu()"
                        tabindex="0"
                        attr.aria-expanded="{{ mobileMenuOpen }}"
                        role="button"
                        attr.aria-label="{{ 'OPEN_NAVIGATION_ARIA_LABEL' | translate }}"></span>
                </div>
            </div>
        </div>

        <gl-mobile-menu
            *ngIf="mobileMenuOpen"
            [mobileMenuOpen]="mobileMenuOpen"
            (didToggleMobileMenu)="toggleMobileMenu()"
            (didCloseMobileMenu)="closeMobileMenu()"
            (didLanguageChange)="changeLanguage($event)"
            (didLogOut)="logout()"></gl-mobile-menu>
    </header>
</div>
